import {Component, ElementRef, ViewChild} from '@angular/core';
import {ItemBase} from "../item-base";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-navbar-item-large',
  templateUrl: './navbar-item-large.component.html',
  imports: [
    RouterLinkActive,
    RouterLink
  ],
  styleUrls: ['./navbar-item-large.component.scss']
})
export class NavbarItemLargeComponent extends ItemBase {
  @ViewChild('item') item!: ElementRef;
}
